// extracted by mini-css-extract-plugin
export var closeButton = "_c6-1";
export var closeX = "_c6-3";
export var container = "_c6-0";
export var image = "_c6-2";